'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _loadingAdminForm = require('./loading-admin-form.component');

var _loadingAdminForm2 = _interopRequireDefault(_loadingAdminForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _angular2.default.module('components.app.product.loadingAdminForm', []).component('loadingAdminForm', _loadingAdminForm2.default).value('EventEmitter', function (payload) {
  return { $event: payload };
}).name;


// WEBPACK FOOTER //
// ./components/app/product/loading-admin-form/loading-admin-form.module.js